var render, staticRenderFns
import script from "./YellowBuckets.vue?vue&type=script&lang=js&"
export * from "./YellowBuckets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a687b6",
  null
  
)

export default component.exports